import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { Input } from "antd"; // Import Input component for better search input styling

export interface DatatableProps {
  columns: any[]; // Replace `any` with your data row type if known
  dataSource: any[]; // Can be replaced with a stricter type
  Selection?: boolean; // Optional property for selection state
  setDataSource?: (data: any[]) => void; // Function to update dataSource
  pageSize?: number;
  pageSizeOptions?: number[];
  withSearch?: boolean;
  withPagination?: boolean;
}

const Datatable: React.FC<DatatableProps> = ({
  columns,
  dataSource,
  Selection,
  pageSize = 10,
  pageSizeOptions = [10, 20, 30],
  withSearch = true,
  withPagination = false,
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
  const [searchText, setSearchText] = useState<string>("");
  const [Selections, setSelections] = useState<boolean>(false);
  const [filteredDataSource, setFilteredDataSource] = useState(dataSource || []);

  const onSelectChange = (newSelectedRowKeys: any[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const handleSearch = (value: string) => {
    setSearchText(value);
    // Only filter if search text is 3 or more characters
    if (value.length < 3) {
      setFilteredDataSource(dataSource);
      return;
    }
    const filteredData = dataSource.filter((record) =>
      Object.values(record).some((field) =>
        String(field).toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredDataSource(filteredData);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  // Update the selection state based on the passed prop (default remains false)
  useEffect(() => {
    if (Selection !== undefined) {
      setSelections(Selection);
    }
  }, [Selection]);

  // Update filtered data when dataSource changes
  useEffect(() => {
    setFilteredDataSource(dataSource);
  }, [dataSource]);

  return (
    <>
      {withSearch && (
        <div className="p-2 table-top-data d-flex justify-content-between align-items-center mb-3">
          {/* Search Input (Left Side) */}
          <div className="search-global" style={{ flex: 1, marginRight: "16px" }}>
            <Input
              placeholder="Search..."
              value={searchText}
              onChange={(e) => handleSearch(e.target.value)}
              allowClear
              style={{ width: "100%" }}
            />
          </div>

         
        </div>
      )}

      {/* Table */}
      {Selections ? (
        // Render table with checkboxes if Selections is true
        <Table
          className="table datanew dataTable no-footer"
          rowSelection={rowSelection}
          columns={columns}
          rowHoverable={false}
          dataSource={filteredDataSource}
          pagination={
            withPagination
              ? {
                  locale: { items_per_page: "" },
                  nextIcon: <span>Next</span>,
                  prevIcon: <span>Prev</span>,
                  defaultPageSize: pageSize,
                  showSizeChanger: true,
                  pageSizeOptions: pageSizeOptions,
                }
              : false
          }
        />
      ) : (
        // Render table without checkboxes by default
        <Table
          className="table datanew dataTable no-footer"
          columns={columns}
          rowHoverable={false}
          dataSource={filteredDataSource}
          pagination={
            withPagination
              ? {
                  locale: { items_per_page: "" },
                  nextIcon: <span>Next</span>,
                  prevIcon: <span>Prev</span>,
                  defaultPageSize: pageSize,
                  showSizeChanger: true,
                  pageSizeOptions: pageSizeOptions,
                }
              : false
          }
        />
      )}
    </>
  );
};

export default Datatable;